import React from "react";
import { useStore } from "@/context/StoreContext";
import { Building2 } from "lucide-react";

// Wrapper: pagine operative richiedono una sede selezionata (non "Tutti")
export default function RequireStore({ children }) {
  const { storeId, currentStore } = useStore();
  if (storeId === "all" || !currentStore) {
    return (
      <div className="flex flex-col items-center justify-center rounded-2xl border border-border bg-card px-6 py-20 text-center" data-testid="require-store-notice">
        <Building2 className="mb-3 h-12 w-12 text-primary" />
        <h2 className="font-display text-xl font-bold">Seleziona un punto vendita</h2>
        <p className="mt-1 max-w-md text-sm text-muted-foreground">
          Questa sezione opera su una singola sede. Scegli un punto vendita dal selettore in alto per continuare.
        </p>
      </div>
    );
  }
  return children;
}
